export var logger = console;